import script from "./EditContactModal.vue?vue&type=script&setup=true&lang=js"
export * from "./EditContactModal.vue?vue&type=script&setup=true&lang=js"

import "./EditContactModal.vue?vue&type=style&index=0&id=4a422b9b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4a422b9b"]])

export default __exports__